import { useContext } from "react";
import { AppContext } from "../contexts/appContext";

const useAppContext = () => {
  return useContext(AppContext);
};

export default useAppContext;
